/// <amd-module name="Feed/Legacy/Helpers/ProjectHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { Feed } from "Feed/Common/Contracts/Feed";
import * as PackageResources from "Feed/Common/Resources";

import { IPackageProtocol } from "../Protocols/Common/IPackageProtocol";
import { ISupportedFeatures } from "../Protocols/Common/ISupportedFeatures";

export function getCurrentSelectedProjectName(
    pageContext: IVssPageContext,
    contributionService: IVssContributionService = null
): string {
    const tfsProject = getTfsProject(pageContext, contributionService);
    return tfsProject ? tfsProject.name : null;
}

export function getCurrentSelectedProjectId(
    pageContext: IVssPageContext,
    contributionService: IVssContributionService = null
): string {
    const tfsProject = getTfsProject(pageContext, contributionService);
    return tfsProject ? tfsProject.id : null;
}

export function getProjectIdForProtocol(feed: Feed, protocolProvider: IPackageProtocol): string {
    const protocolSupportedFeatures: ISupportedFeatures = protocolProvider.supportedFeatures();
    return feed.project && protocolSupportedFeatures.projectScopedFeeds ? feed.project.id : null;
}

export function isPublicFeed(feed: Feed) {
    if (!feed || !feed.project) {
        return false;
    }

    return feed.project.visibility == PackageResources.Public;
}

function getTfsProject(
    pageContext: IVssPageContext,
    contributionService: IVssContributionService = null
    // tslint:disable-next-line:no-any
): any {
    contributionService =
        contributionService || pageContext.getService<IVssContributionService>("IVssContributionService");

    // ITfsPageData type exists in Tfs.Web but not taking dependency on that module
    // tslint:disable-next-line:no-any
    const tfsPageData = contributionService.getData<any>("ms.vss-tfs-web.page-data");

    return tfsPageData ? tfsPageData.project : null;
}
